module.exports = __webpack_public_path__ + "img/status-replayed.f2fc872d.svg";